import type { ShipmentManagement } from "~/shared/schemas/shipment-management-schema.ts";

type LockableShipment = Pick<
	ShipmentManagement,
	"loadAccess" | "shipmentDetails"
>;

export const isSentToAccounting = (shipment: LockableShipment): boolean =>
	shipment.shipmentDetails?.additionalDetails?.sendToAccounting === true ||
	(shipment.loadAccess?.statuses?.includes("Accounting") ?? false);

type StatusLock = {
	label: string;
	isActive: (shipment: LockableShipment) => boolean;
};

// Conditions that lock the whole shipment page, with the header pill label for each.
const STATUS_LOCKS: readonly StatusLock[] = [
	{ label: "Accounting Processing", isActive: isSentToAccounting },
];

export const getStatusLockLabel = (
	shipment: LockableShipment | null | undefined,
): string | null =>
	(shipment && STATUS_LOCKS.find((lock) => lock.isActive(shipment))?.label) ??
	null;
